// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links_Links__yLW8p"};